import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const inboxChannel = defineChannel({
  id: 'inbox',
  icon: 'notifications',
  name: 'Inbox message',
  shortName: 'Inbox Message',
  noun: 'inbox message',
  events: ['attempted', 'sent', 'deferred', 'failed', 'opened', 'converted', 'drafted', 'undeliverable'],
} as const satisfies ChannelDefinition);
